export default "__VITE_ASSET__C6X2fDe3__"